import { ReceiverDTO } from '@/models/receiver-dto'
import { TransactionDTO } from '@/models/transaction-dto'
import moment from 'moment'

/**
 * Nom à afficher pour un destinataire dans la liste des destinataires (et partout où ce nom sert
 * à l'identifier avant un envoi) : le nom vérifié par l'opérateur (Orange/MTN) une fois confirmé
 * par le client, sinon le nom saisi sur la fiche (firstName/lastName). On ne modifie jamais
 * firstName/lastName eux-mêmes pour un contact enregistré (voir markReceiverNameVerified côté
 * backend) — c'est uniquement l'affichage qui préfère le nom vérifié quand il est disponible.
 */
export function receiverDisplayName(receiver: ReceiverDTO): string {
  if (receiver.nameVerified && receiver.verifiedRecipientName) {
    return receiver.verifiedRecipientName
  }
  return `${receiver.firstName} ${receiver.lastName}`
}

/**
 * Format a date and time to DD/MM/YYYY - HH:mm
 * @param date
 * @returns
 */
export function formatDateTime(date: Date): string {
  return moment(date).format('DD/MM/YYYY - HH:mm')
}

/**
 * Format a date to DD/MM/YYYY
 * @param date
 * @returns
 */
export function formatDate(date?: Date): string {
  return moment(date).format('DD/MM/YYYY')
}

/**
 * Format a date like this: 01 Jan. 2021
 * @param date
 * @returns Formatted date
 */
export function formatDateWithMonthName(date?: Date): string {
  return moment(date).format('DD MMM. YYYY')
}

/**
 * Sort a list of TransactionDTO by date DESC
 * @param list
 * @returns
 */
export function sortListOfTransactionDTOByDateDESC(list: TransactionDTO[]): TransactionDTO[] {
  return list.sort((a: TransactionDTO, b: TransactionDTO) => {
    if (a.transactionDate! === b.transactionDate!) {
      return 0
    }

    return a.transactionDate! < b.transactionDate! ? 1 : -1
  })
}

/**
 * @description Check if user is logged in
 * @returns
 */
export function checkLoggedIn(): boolean {
  const token = localStorage.getItem('token')
  return !!token
}

/**
 *
 * @param value Amount to format
 * @returns Amount formated
 */
export function formatAmount(value: string | number): string {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
  return `0.00`
}

/**
 * @description get the app URL: ie. http://localhost:8080
 * @returns App URL
 */
export function getAppBaseUrl(): string {
  return window.location.origin
}

/**
 * @param file
 * @param filename
 */
export function downloadFile(file: Blob, filename: string) {
  const url = window.URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', formatFileName(filename))
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * @param fileName
 */
function formatFileName(fileName: string): string {
  const now: string = moment().format('DD-MM-YYYY-hh:mm:ss-a')
  const ext = fileName.split('.').pop()
  const fileNameWithoutExt = fileName.split('.').shift()
  return `${fileNameWithoutExt}_${now}.${ext}`
}
